import { useRef } from 'react';
import { useNavigationContainerRef } from 'expo-router';

import { useIsFocused } from '@sg/garnish';

import type { ScreenOptions } from '../../constants';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns the current screen options while the caller's navigator is focused.
 * Retains those options while another navigator is presented over it.
 */
export const useActiveScreenOptions = () => {
  const navigationRef = useNavigationContainerRef();
  const isFocused = useIsFocused();

  const isReady = isFocused && navigationRef.isReady();

  // ─── Refs ─────────────────────────────────────────────────────────────────

  const screenOptionsRef = useRef<ScreenOptions | undefined>(
    isReady ? navigationRef?.getCurrentOptions?.() : undefined,
  );

  // ──────────────────────────────────────────────────────────────────────────

  if (isReady) {
    screenOptionsRef.current = navigationRef?.getCurrentOptions?.();
  }

  return screenOptionsRef.current;
};
